import React from 'react';

const ActionModal = (props) => {
  const { children, active, onCancel } = props;
  return (
    <>
      <div className={`action_modal ${active ? 'active' : ''}`}>
        <div className="action_modal_body">{children}</div>
      </div>

      <div
        onClick={() => {
          if (onCancel) onCancel();
        }}
        className={`action_modal_overlay ${active ? 'active' : ''}`}
      />
    </>
  );
};

export default ActionModal;
